import React from 'react';
import { Link } from 'react-router-dom';
import { heroArtwork } from '../../../data/heroArtwork';
import { useLanguage } from '../../../contexts/LanguageContext';
import { MenuButton } from '../../layout/MenuButton';
import { ShopNowButton } from '../../shop/ShopNowButton';
import { WarrantyBanner } from '../../shop/WarrantyBanner';
import { HoloBanner } from './HoloBanner';
const pct = (v: number, total: number) => `${v / total * 100}%`;

/** Desktop (≥1024px): full landscape artwork with live controls positioned on it. */
export function HeroDesktop() {
  const {
    t
  } = useLanguage();
  const {
    desktop
  } = heroArtwork;
  const {
    width: W,
    height: H
  } = desktop;
  return <div className="hidden lg:block" data-id="element-223" data-mp="1iznbmk55cwzb">
      <div className="relative w-full bg-deep" data-id="element-224" data-mp="1iylwo4l0fqcb">
        <img src={desktop.src} width={W} height={H} alt={heroArtwork.alt} loading="eager" decoding="async" draggable={false} className="block h-auto w-full select-none" data-id="element-225" data-mp="26phnaydqcfhz" />
        <h1 className="sr-only" data-id="element-226" data-mp="2b4bqr5xbdc9s">
          {t('hero.headline')} {t('hero.brand')}
        </h1>

        <MenuButton className="absolute right-[1.6%] top-[2.6%] bg-[#030A14]/50 backdrop-blur-sm" data-id="element-227" data-mp="273ryogrlkyui" />

        {/* SHOP NOW sits in the free band under the headline; scales with the artwork. */}
        <div className="absolute" style={{
        left: pct(desktop.shopNow.x, W),
        top: pct(desktop.shopNow.y, H)
      }} data-id="element-228" data-mp="2g23ncd8wlmkb">
          <ShopNowButton source="hero" className="!h-[clamp(34px,3.4vw,58px)] !rounded-[clamp(8px,0.7vw,14px)] !px-[clamp(14px,1.6vw,30px)] !text-[clamp(12px,1.02vw,18px)]" data-id="element-229" data-mp="2upye3o3cpgur" />
        </div>

        {/* The artwork's M1 PRO links to the product page. */}
        <Link to="/m1-pro" aria-label="Explore the M1 PRO" className="absolute rounded-full focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-ice" style={{
        left: pct(desktop.product.x, W),
        top: pct(desktop.product.y, H),
        width: pct(desktop.product.w, W),
        height: pct(desktop.product.h, H)
      }} data-id="element-230" data-mp="2yuo6v42pqfbg" />
      </div>

      <HoloBanner data-id="element-231" data-mp="3ef9gdi0l8wve" />
      <WarrantyBanner data-id="element-232" data-mp="3eepw3ungtwe7" />
    </div>;
}